module.exports = require("nba-stats-client");


//////////////////
// WEBPACK FOOTER
// external "nba-stats-client"
// module id = 32
// module chunks = 0